import { IHttpClient } from "../../../lib/http";
import {
  EngineGuestDataDto,
  EngineGuestDataEntity,
  StringBoolean,
  StringBooleanMapping,
} from "../domain/engineGuestData.entity";

function toStringBoolean(prop: boolean) {
  return StringBooleanMapping[prop ? "true" : "false"];
}

function toBoolean(prop: StringBoolean | boolean) {
  if (typeof prop == "boolean") {
    return prop;
  }
  return prop === "1";
}

function entityToDto(entity: EngineGuestDataEntity): EngineGuestDataDto {
  return {
    esDatosReservaDni: toStringBoolean(entity.bookingFormDni),
    esDatosReservaDireccion: toStringBoolean(entity.bookingFormAddress),
    esDatosReservaEmailRepeat: toStringBoolean(entity.bookingFormRepeatEmail),
    esDatosReservaPais: toStringBoolean(entity.bookingFormCountry),
    esDatosReservaTelefono: toStringBoolean(entity.bookingFormPhone),
    esDatosReservaCiudad: toStringBoolean(entity.bookingFormCity),
    esDatosReservaCodigoPostal: toStringBoolean(entity.bookingFormPostalCode),
    require_arrival_time: toStringBoolean(entity.bookingFormArrivalTime),
    esDatosReservaPeticionOferta: toStringBoolean(entity.bookingFormNewsletter),
  };
}

// we do not need entity to have a distinct id because it's not used in the API
const baseUUID = "3639076e-8f86-442f-b1c6-d123b718b9c7";

function dtoToEntity(dto: EngineGuestDataDto): EngineGuestDataEntity {
  return {
    id: baseUUID,
    bookingFormDni: toBoolean(dto.esDatosReservaDni),
    bookingFormAddress: toBoolean(dto.esDatosReservaDireccion),
    bookingFormRepeatEmail: toBoolean(dto.esDatosReservaEmailRepeat),
    bookingFormCountry: toBoolean(dto.esDatosReservaPais),
    bookingFormPhone: toBoolean(dto.esDatosReservaTelefono),
    bookingFormArrivalTime: toBoolean(dto.require_arrival_time),
    bookingFormNewsletter: toBoolean(dto.esDatosReservaPeticionOferta),
    bookingFormCity: toBoolean(dto.esDatosReservaCiudad),
    bookingFormPostalCode: toBoolean(dto.esDatosReservaCodigoPostal),
  };
}

function buildUrlParams(): URLSearchParams {
  const dto: EngineGuestDataDto = {
    esDatosReservaDni: "0",
    esDatosReservaDireccion: "0",
    esDatosReservaEmailRepeat: "0",
    esDatosReservaPais: "0",
    esDatosReservaTelefono: "0",
    esDatosReservaCiudad: "0",
    esDatosReservaCodigoPostal: "0",
    require_arrival_time: "0",
    esDatosReservaPeticionOferta: "0",
  };
  const params = new URLSearchParams();
  Object.keys(dto).forEach(k => params.append("prop", k));
  return params;
}

export async function getEntity(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<EngineGuestDataEntity> {
  const params: URLSearchParams = buildUrlParams();
  const dto: EngineGuestDataDto = await httpClient.get<EngineGuestDataDto>(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/configurations`,
    { params }
  );
  return dtoToEntity(dto);
}

export async function updateEntity(
  propertyTicker: string,
  entity: EngineGuestDataEntity,
  httpClient: IHttpClient
): Promise<void> {
  await httpClient.post(
    `/WitBookerAPI-war/webresources/endpoint/establishment/${propertyTicker}/createOrUpdateConfigurations`,
    entityToDto(entity)
  );
}
